

























































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';

import { CompletionStatus, ExperimentGetter, MobileGetter, User } from 'frontend/types';
import { RelatedLearningPathInfo } from 'frontend/types/learningPathV2';

@Component({
  computed: {
    ...mapState('globals', ['user']),
    ...mapState('isFirstCourse', ['didNotStartALesson']),
    ...mapGetters('pageHeader', ['isMobile']),
    ...mapGetters('relatedLearningPathInfo', ['learningPath']),
  },
})
export default class LessonButton extends Vue {
  private readonly user!: User;
  private readonly isMobile!: MobileGetter;
  private readonly didNotStartALesson!: boolean;
  private readonly learningPath?: RelatedLearningPathInfo;

  @Prop({ type: String, required: true })
  private link!: string;
  @Prop({ type: Boolean, required: true })
  private isLocked!: boolean;
  @Prop({ type: String, required: true })
  private completionStatus!: CompletionStatus;
  @Prop({ type: Boolean, default: false })
  private isRecommended!: boolean;
  @Prop({ type: Boolean, default: false })
  private isPractice!: boolean;
  @Prop({ type: Number, default: 0 })
  private practiceLessons!: number;
  @Prop({ type: Boolean, default: false })
  private isHighlighted!: boolean;
  @Prop({ type: Boolean, default: false })
  private isLast!: boolean;
  @Prop({ type: Object, required: true })
  private trackingPayload!: { axId: string; axType: string; axExtra: any };

  private get lessonButtonStateClass(): string {
    if (this.isLocked) {
      return 'locked';
    }
    if (this.isRecommended) {
      return 'recommended';
    }
    if (this.isHighlighted && this.completionStatus !== 'completed') {
      return 'highlighted';
    }

    return this.completionStatus;
  }

  private get isInLLPRolloutExperiment(): boolean {
    return !!this.learningPath;
  }

  private preventIfLocked(event: Event): void {
    if (!this.user.is_authenticated || this.isLocked) {
      event.preventDefault();
      this.$emit('access-prevented');
    }
  }
}
